import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';

export const listAnimation = trigger('list', [
  transition(':enter', [
    // child animation selector + stagger
    query('@item',
      stagger(20, animateChild())
    )
  ]),
]);

export const itemAnimation = trigger('item', [
  transition(':enter', [
    style({opacity: 0, transform: 'translateX(50%)'}),
    animate('500ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
  ]),
  transition(':leave', [
    style({ opacity: 1}),
    animate('1s cubic-bezier(.8,-0.6,0.2,1.5)',
      style({ transform: 'scale(0.5)', opacity: 0 }))
  ])
]);
